module.exports = __webpack_public_path__ + "static/mark_foster-react-developer-a73eb16c7cd79961ce0c7b4e9b384455.jpg";